/**
 * This potentially can be replaced by the much more succint String.repalce with special chars, but beware the Safari does not support ( negative ) lookbehinds
 * 
 * export const getCdkClassFileName = (projectName: string) => projectName.replace(/(?<!^)([A-Z])/g, '-$1').toLowerCase() // does this match work? yes see unit test

 */

// attempts to support vs code style search and replace regex with group placeholders as $1 $2 etc
export const replacer = (regex: RegExp, replacement: string, str: string) => {
  const res = regex.exec(str)
  if (res) {
    const [searched, ...groups] = res
    groups.forEach((group, i) => {
      replacement = replacement.replace(`\$${i + 1}`, group)
    })
    str = str.replace(searched, replacement)
    replacer(regex, replacement, str)
  } else {
    console.log('Res was null', { str, regex, res })
  }
  return str
}

export const getMatches = (regex: RegExp, str: string, i: number = 0) => {
  let matches: string[] = []
  if (regex.lastIndex === 0) {
    regex = new RegExp(regex, 'gm') // in case we forget
  }

  const res = regex.exec(str)
  if (res) {
    const [searched, ...groups] = res
    groups.forEach((group, i) => {
      matches.push(group)
    })
    matches = matches.concat(getMatches(regex, str, i + 1))
  } else {
    // console.log('Res was null', { str, regex, res, matches })
  }
  return matches
}
